import middleware from './middleware';
import * as actions from './actions';

export default {
    actions,
    middleware,
};
